import * as Yup from 'yup';

export const FirmStrategyEditInvestmentFormValidationSchema = Yup.object().shape(
  {
    Title: Yup.string()
      .max(50, 'You have exceeded the maximum number of 50 characters')
      .required('This field is required'),

    Content: Yup.object()
      .test(
        'is-empty',
        'This field is required',
        value => value && value.getCurrentContent().hasText()
      )
      .test(
        'max-length',
        'You have exceeded the maximum number of 10000 characters',
        value =>
          value && value.getCurrentContent().getPlainText().length <= 10000
      ),

    OwnershipStyle: Yup.string()
      .max(255, 'You have exceeded the maximum number of 255 characters')
      .required('This field is required'),

    CompanySizeID: Yup.object()
      .nullable()
      .required('This field is required'),

    InvestmentSize: Yup.string()
      .max(255, 'You have exceeded the maximum number of 255 characters')
      .required('This field is required'),

    Geography: Yup.string()
      .max(255, 'You have exceeded the maximum number of 255 characters')
      .required('This field is required'),

    IndustrySectors: Yup.string()
      .max(255, 'You have exceeded the maximum number of 255 characters')
      .required('This field is required'),

    TransactionTypes: Yup.string()
      .max(255, 'You have exceeded the maximum number of 255 characters')
      .required('This field is required'),
  }
);
